/**
 * Canonical plan keys match API `subscription_plan` / Stripe checkout `planName`.
 * UI label "Scale" maps to planKey `Platinum`.
 *
 * Display amounts match active Stripe monthly prices. Price IDs: local/test
 * fallbacks below; production sets REACT_APP_STRIPE_*_MONTHLY_PRICE_ID at
 * build time (.env.production). Do not put "$" amounts in .env — dotenv expands them.
 */

const CREATOR_PAYOUT_SERVICE_FEE = '5% service fee on creator payouts';

/** @type {Array<{
 *   planKey: string,
 *   displayName: string,
 *   tagline: string,
 *   monthlyPrice: string,
 *   monthlyPriceId: string | null,
 *   priceSubtext: string,
 *   isContactOnly?: boolean,
 *   recommended?: boolean,
 *   features: string[],
 * }>}
 */
const MILLET_PRICING_PLANS = [
  {
    planKey: 'Starter',
    displayName: 'Starter',
    tagline: 'Launch your first live campaigns.',
    monthlyPrice: '$99.00',
    monthlyPriceId:
      process.env.REACT_APP_STRIPE_STARTER_MONTHLY_PRICE_ID || 'price_1PvrGME2ipzuRLRS0wUH3KUb',
    priceSubtext: 'per month · billed monthly',
    features: [
      '10 creator invites / month',
      '5 campaigns / month',
      CREATOR_PAYOUT_SERVICE_FEE,
    ],
  },
  {
    planKey: 'Growth',
    displayName: 'Growth',
    tagline: 'Run campaigns at scale.',
    recommended: true,
    monthlyPrice: '$299.00',
    monthlyPriceId:
      process.env.REACT_APP_STRIPE_GROWTH_MONTHLY_PRICE_ID || 'price_1QTCezE2ipzuRLRSzZT2jYGF',
    priceSubtext: 'per month · billed monthly',
    features: [
      '200 creator invites / month',
      '20 campaigns / month',
      CREATOR_PAYOUT_SERVICE_FEE,
    ],
  },
  {
    planKey: 'Platinum',
    displayName: 'Scale',
    tagline: 'Maximum throughput for serious teams.',
    monthlyPrice: '$999.00',
    monthlyPriceId:
      process.env.REACT_APP_STRIPE_PLATINUM_MONTHLY_PRICE_ID || 'price_1QTCg6E2ipzuRLRSVTUEFK7B',
    priceSubtext: 'per month · billed monthly',
    features: [
      '500 creator invites / month',
      '100 campaigns / month',
      'Priority support',
      CREATOR_PAYOUT_SERVICE_FEE,
    ],
  },
];

export default MILLET_PRICING_PLANS;
